import { useEffect, useState } from "react";
import Footer from "../../../component/Footer";
import { Link } from "react-router-dom";
import Sidebar from "../AdminComp/Sidebar";
import BreadCrumb from "../AdminComp/BreadCrumb";
import { Eye } from "react-feather";
import { baseurl } from "../../../component/Baseurl";
import axios from "axios";
import AdminBookingNavbar from "./AdminBookingNavbar";

function AdminFlightBookingReport() {
  const [bookingData, setBookingData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch flight bookings from API
  const fetchFlightBookings = async () => {
    try {
      const response = await axios.get(`${baseurl}getAllFlightBookings`);
      console.log("API Response:", response.data);

      if (response.data) {
        setBookingData(response.data);
      } else {
        setBookingData([]);
      }
    } catch (error) {
      console.error("Error fetching flight bookings:", error);
      setError("Failed to load bookings.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFlightBookings();
  }, []);

  return (
    <>
      <div className="App" style={{ display: "flex" }}>
        <Sidebar />

        {/* Content area */}
        <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
          <div>
            <BreadCrumb />
            <div className="container-fluid">
              <AdminBookingNavbar />

              <div className="crdmain mb-2">
                <div className="d-flex justify-content-between align-items-center" style={{ width: "100%" }}>
                  <h2 className="chart-title mb-0">Flight Booking Report</h2>
                </div>

                {/* Show loading or error */}
                {loading && <p>Loading bookings...</p>}
                {error && <p className="text-danger">{error}</p>}

                {!loading && !error && (
                  <div className="row g-2 mt-0 mb-0">
                    <div className="col-md-12 p-2">
                      {/* Table */}
                      <div className="table-responsive classic-table">
                        <table className="table table-striped table-hover">
                          <thead className="table-header">
                            <tr>
                              <th>#</th>
                              <th>Unique ID</th>
                              <th>First Name</th>
                              <th>Last Name</th>
                              <th>Phone</th>
                              <th>Email</th>
                              <th>Country</th>
                              <th>Status</th>
                              <th>API Message</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {bookingData.length > 0 ? (
                              bookingData.map((booking, index) => (
                                <tr key={booking.id}>
                                  <td>{index + 1}</td>
                                  <td>{booking.unique_id}</td>
                                  <td>{booking.firstname}</td>
                                  <td>{booking.lastname}</td>
                                  <td>{booking.contactno}</td>
                                  <td>{booking.email}</td>
                                  <td>{booking.countryname}</td>
                                  <td>
                                    <span className={`badge ${booking.api_response?.Status === 0 ? "bg-danger" : "bg-success"}`}>
                                      {booking.api_response?.Status === 0 ? "Failed" : "Success"}
                                    </span>
                                  </td>
                                  <td>{booking.api_response?.Message || "N/A"}</td>
                                  <td>
                                    <span className="btn2 me-2" title="View Details">
                                      <Eye size={15} />
                                    </span>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="10" className="text-center">
                                  No bookings found.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminFlightBookingReport;
